import Skeleton from "@mui/material/Skeleton";
import React from "react";

const TextSkeleton = () => {
  return (
    <>
      {Array.from({ length: 20 }).map((_, index) => (
        <Skeleton
          key={index}
          variant="text"
          height={24}
          width={`${Math.floor(Math.random() * 220) + 40}px`}
          sx={{ display: "inline-block", mr: 1 }}
        />
      ))}
    </>
  );
};

const memoizedTextSkeleton = React.memo(TextSkeleton);
export default memoizedTextSkeleton;
